/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CashoutCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PagedModelCashOutDto, CashOutDto, PaymentResponseDto, TransfertDetails, ReceiptMeanDto } from "../models";

@Injectable({ providedIn: "root" })
export class CashoutCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getCashout(idPartner?: number, size?: number, page?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelCashOutDto>;
    getCashout(idPartner?: number, size?: number, page?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelCashOutDto>>;
    getCashout(idPartner?: number, size?: number, page?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelCashOutDto>>;
    getCashout(idPartner?: number, size?: number, page?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cashout`;

        let params = new HttpParams();
        if (idPartner != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idPartner, 'idPartner');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    cashoutMoney(cashOutDto: CashOutDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    cashoutMoney(cashOutDto: CashOutDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    cashoutMoney(cashOutDto: CashOutDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    cashoutMoney(cashOutDto: CashOutDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cashout`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: cashOutDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateCashout(id: number, status: 'VALIDATED' | 'PAID' | 'PENDING' | 'CANCELED' | 'FAILED', observe?: 'body', options?: RequestOptions<'json'>): Observable<TransfertDetails>;
    updateCashout(id: number, status: 'VALIDATED' | 'PAID' | 'PENDING' | 'CANCELED' | 'FAILED', observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TransfertDetails>>;
    updateCashout(id: number, status: 'VALIDATED' | 'PAID' | 'PENDING' | 'CANCELED' | 'FAILED', observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TransfertDetails>>;
    updateCashout(id: number, status: 'VALIDATED' | 'PAID' | 'PENDING' | 'CANCELED' | 'FAILED', observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cashout`;

        let params = new HttpParams();
        if (id != null) {
            params = HttpParamsBuilder.addToHttpParams(params, id, 'id');
        }
        if (status != null) {
            params = HttpParamsBuilder.addToHttpParams(params, status, 'status');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getReceiptMeans(idPartner: number, receiptNetwork?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<ReceiptMeanDto>>;
    getReceiptMeans(idPartner: number, receiptNetwork?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<ReceiptMeanDto>>>;
    getReceiptMeans(idPartner: number, receiptNetwork?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<ReceiptMeanDto>>>;
    getReceiptMeans(idPartner: number, receiptNetwork?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cashout/receiptMeans`;

        let params = new HttpParams();
        if (idPartner != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idPartner, 'idPartner');
        }
        if (receiptNetwork != null) {
            params = HttpParamsBuilder.addToHttpParams(params, receiptNetwork, 'receiptNetwork');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addReceiptMean(receiptMeanDto: ReceiptMeanDto, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    addReceiptMean(receiptMeanDto: ReceiptMeanDto, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    addReceiptMean(receiptMeanDto: ReceiptMeanDto, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    addReceiptMean(receiptMeanDto: ReceiptMeanDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/cashout/receiptMeans`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: receiptMeanDto,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
